var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916672 20.5003C0.916672 9.68445 9.68413 0.916992 20.5 0.916992C31.3159 0.916992 40.0833 9.68445 40.0833 20.5003C40.0833 31.3162 31.3159 40.0837 20.5 40.0837C9.68413 40.0837 0.916672 31.3162 0.916672 20.5003ZM20.5 4.83366C16.3449 4.83366 12.3601 6.48425 9.422 9.42232C6.48393 12.3604 4.83334 16.3453 4.83334 20.5003C4.83334 24.6554 6.48393 28.6403 9.422 31.5783C12.3601 34.5164 16.3449 36.167 20.5 36.167C24.6551 36.167 28.6399 34.5164 31.578 31.5783C34.5161 28.6403 36.1667 24.6554 36.1667 20.5003C36.1667 16.3453 34.5161 12.3604 31.578 9.42232C28.6399 6.48425 24.6551 4.83366 20.5 4.83366Z",
    fill: "#50869A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4583 10.7083C22.4583 10.189 22.252 9.69084 21.8848 9.32358C21.5175 8.95632 21.0194 8.75 20.5 8.75C19.9806 8.75 19.4825 8.95632 19.1152 9.32358C18.748 9.69084 18.5417 10.189 18.5417 10.7083V18.5417H10.7083C10.189 18.5417 9.69084 18.748 9.32358 19.1152C8.95632 19.4825 8.75 19.9806 8.75 20.5C8.75 21.0194 8.95632 21.5175 9.32358 21.8848C9.69084 22.252 10.189 22.4583 10.7083 22.4583H18.5417V30.2917C18.5417 30.811 18.748 31.3092 19.1152 31.6764C19.4825 32.0437 19.9806 32.25 20.5 32.25C21.0194 32.25 21.5175 32.0437 21.8848 31.6764C22.252 31.3092 22.4583 30.811 22.4583 30.2917V22.4583H30.2917C30.811 22.4583 31.3092 22.252 31.6764 21.8848C32.0437 21.5175 32.25 21.0194 32.25 20.5C32.25 19.9806 32.0437 19.4825 31.6764 19.1152C31.3092 18.748 30.811 18.5417 30.2917 18.5417H22.4583V10.7083Z",
    fill: "#50869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowmore);
export default __webpack_public_path__ + "static/media/showmore.070d59c817baabc0bf035de10c27b260.svg";
export { ForwardRef as ReactComponent };